import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import Logo from '@/components/Logo';

import styles from './footer.module.css';

const FooterSimple = () => {
  const { t } = useTranslation();

  return (
    <footer className={classNames(styles.root, styles.simple)}>
      <div className={classNames(styles.container, 'container')}>
        <div className={styles.createWithForma}>
          {t('create_documents_with_forma')} <Logo className={styles.logo} />
        </div>
      </div>
    </footer>
  );
};

export default FooterSimple;
